<template>
    <el-form ref="form" :model="value" label-position="top">
        <Panel title="组件配置">
            <el-row>
                <el-col :span='12'>
                    <el-form-item label="加密机密码">
                        <el-input v-model="value.ukeyPassword"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
        <Panel title="高级配置" collapse>
            <el-row>
                <el-col :span='12'>
                    <el-form-item label="加密机设备名称">
                        <el-input v-model="value.deviceName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item label="加密机根证书路径">
                        <el-input v-model="value.rootCertDir"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item label="追加证书">
                        <el-radio v-model="value.isAppendCert" :label="true">是</el-radio>
                        <el-radio v-model="value.isAppendCert" :label="false">否</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
    </el-form>
</template>

<script>
export default {
    // ukeyPassword;
    // deviceName = "USBKey";
    // rootCertDir;
    props: {
        value: Object,
        init: Boolean
    },
    mounted() {
        if (this.init) {
            this.$set(this.value, 'deviceName', 'USBKey');
            this.$set(this.value, 'rootCertDir', '');
            this.$set(this.value, 'isAppendCert', true);
        }
    },
    methods: {
        validate() {
            return this.$refs.form.validate();
        }
    }
}
</script>

<style scoped>

</style>